module.exports = __webpack_public_path__ + "img/text-share-link-2.31d8f489.png";